module.exports = __webpack_public_path__ + "img/ModuleCheckList.80f49378.png";